/*
 * AMADA BARCELONA · custom.js                                      22-9-2026
 *
 * 🔴 ESTE FICHERO SOLO SE EJECUTA SI theme.liquid LO CARGA. Broadcast lo trae
 * con el <script> comentado; se ha descomentado a propósito. Si algún día el
 * menú vuelve a no abrirse al pulsar, lo primero que hay que mirar es si esa
 * línea sigue viva.
 *
 * Qué arregla: que la sección madre del menú se abra AL PULSARLA, no solo al
 * pasar el ratón por encima. David lo pidió el 22-9 después de probar la
 * tienda con su madre.
 */

(function () {
  'use strict';

  /* ── 1 · ESCRITORIO ──────────────────────────────────────────────────────
     Broadcast monta las madres como <hover-disclosure> y las abre con el
     ratón. Su enlace es `#`, así que pulsar no hacía nada. El componente ya
     expone showDisclosure() y hideDisclosure(): se usan los suyos en vez de
     tocar clases a mano, para que la animación y el aria-expanded sigan
     saliendo de su código y no se desincronicen.                            */
  document.addEventListener('click', function (e) {
    var enlace = e.target.closest && e.target.closest('hover-disclosure > a[data-top-link]');
    if (!enlace) return;

    // Una madre que SÍ lleva a algún sitio se respeta: se navega, no se abre.
    if (enlace.getAttribute('href') !== '#') return;

    var madre = enlace.parentElement;
    e.preventDefault();

    var abierta = madre.classList.contains('is-visible');

    // Solo una abierta a la vez, como con el ratón
    document.querySelectorAll('hover-disclosure.is-visible').forEach(function (otra) {
      if (otra !== madre && typeof otra.hideDisclosure === 'function') otra.hideDisclosure();
    });

    if (abierta) {
      if (typeof madre.hideDisclosure === 'function') madre.hideDisclosure();
    } else {
      if (typeof madre.showDisclosure === 'function') madre.showDisclosure();
    }
  }, false);

  /* ── 2 · MÓVIL · red de seguridad del <details> ──────────────────────────
     El acordeón es nativo y no necesita JavaScript. Pero Safari de iPhone
     tiene desactivado el <summary> cuando se le cambia el `display`, y eso ya
     nos mordió una vez. La CSS lo arregla en origen; esto es el cinturón: si
     un clic sobre la cabecera NO cambia el estado, se cambia a mano.
     Si el nativo funciona, esto no hace nada.                               */
  document.addEventListener('click', function (e) {
    var cab = e.target.closest && e.target.closest('summary.amada-acc__cab');
    if (!cab) return;
    var acc = cab.parentElement;
    if (!acc || acc.tagName !== 'DETAILS') return;
    var antes = acc.open;
    setTimeout(function () {
      if (acc.open === antes) acc.open = !antes;
    }, 0);
  }, false);
})();


/* ── EL POPUP DE KLAVIYO NO MUEVE LA PÁGINA ─────────────────────── 27-9-2026
 *
 * David, viendo en Clarity la compra de las 07:09: con el popup del 10%
 * abierto la página de detrás se deslizaba, y al terminar la clienta acabó
 * abajo del todo de golpe. Klaviyo solo pone `overflow: hidden` en el body (la
 * clase `klaviyo-prevent-body-scrolling`), y en el iPhone eso no siempre frena
 * el dedo ni el salto que da la página al abrirse el teclado en el campo del
 * correo. Mientras esa clase esté puesta, el body se FIJA donde estaba; cuando
 * Klaviyo la quita, se suelta y se vuelve al mismo punto.
 *
 * Va enganchado a la clase de Klaviyo y no a sus eventos a propósito: se cierre
 * el popup por donde se cierre, Klaviyo quita su clase y la página se suelta.
 * Lo peligroso de un bloqueo así es que se quede puesto, y así no puede.
 */
(function () {
  'use strict';
  var b = document.body, y = 0, fijo = false;
  if (!b || !window.MutationObserver) return;

  function aplicar() {
    var quiere = b.classList.contains('klaviyo-prevent-body-scrolling');
    if (quiere && !fijo) {
      y = window.pageYOffset || document.documentElement.scrollTop || 0;
      fijo = true;
      b.style.position = 'fixed';
      b.style.top = (-y) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    } else if (!quiere && fijo) {
      fijo = false;
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      // De golpe al mismo sitio, sin la animación del scroll suave.
      var html = document.documentElement, antes = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      html.style.scrollBehavior = antes;
    }
  }

  new MutationObserver(aplicar).observe(b, { attributes: true, attributeFilter: ['class'] });
  aplicar();
})();


/* ── EL POPUP DE KLAVIYO SOLO SE CIERRA CON LA X ────────────────── 27-9-2026
 *
 * David, probándolo en su iPhone: *«cuando salta el pop-up, al intentar
 * deslizar, se ha cerrado al darle fuera de él… yo pondría que solo le den a
 * la X»*. Klaviyo no tiene ese ajuste (mirado en la configuración publicada del
 * formulario: no hay nada de «cerrar al pulsar fuera»), así que se hace aquí:
 * un toque que cae en el FONDO del popup —el velo o las capas vacías que
 * envuelven al recuadro— no llega a Klaviyo. Se cierra con la X, con «No,
 * gracias» o con la tecla Esc, como siempre.
 *
 * El recuadro es el antepasado común de la X y el campo del correo, así que el
 * campo, «QUIERO MI 10%» y «No, gracias» quedan siempre dentro y nunca se
 * bloquean. En el paso del código (ya sin campo) el recuadro es el primero con
 * fondo pintado; si no se encontrara, no se bloquea nada: mejor que se cierre
 * de más a que no se pueda usar. Probado el 27-9: los 5 toques en el fondo,
 * parados; el del campo del correo, pasa.
 */
(function () {
  'use strict';
  var POPUP = '[role="dialog"][aria-label="POPUP Form"]';

  function pintada(el) {
    var cs = window.getComputedStyle(el);
    var bg = cs.backgroundColor;
    var sinColor = bg === 'transparent' || /rgba\([^)]*,\s*0\)$/.test(bg);
    return !sinColor || (cs.backgroundImage && cs.backgroundImage !== 'none');
  }

  function recuadro(dlg) {
    var x = dlg.querySelector('.klaviyo-close-form');
    if (!x) return null;
    var campo = dlg.querySelector('input, textarea, select');
    if (campo) {
      var a = x;
      while (a && a !== dlg && !a.contains(campo)) a = a.parentElement;
      if (a && a !== dlg) return a;
    }
    for (var e = x.parentElement; e && e !== dlg; e = e.parentElement) {
      if (pintada(e)) return e;
    }
    return null;
  }

  function esFondo(ev) {
    var t = ev.target;
    var dlg = t && t.closest && t.closest(POPUP);
    if (!dlg) return false;
    var r = recuadro(dlg);
    return !!r && t !== r && t.contains(r);
  }

  ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchend']
    .forEach(function (tipo) {
      window.addEventListener(tipo, function (ev) {
        if (!esFondo(ev)) return;
        ev.stopPropagation();
        if (tipo === 'click') ev.preventDefault();
      }, true);
    });
})();
